import "./ContactLayout.css";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils/index";
import PremiumLoader from "../Loader/PremiumLoader";

export default function ContactLayout() {
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    website: "",
    phone: "",
    requirement: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!contactForm.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!contactForm.email.trim()) {
      newErrors.email = "Email is required";
    }
    if (!contactForm.phone.trim()) {
      newErrors.phone = "Phone number is required";
    }
    if (!contactForm.website.trim()) {
      newErrors.website = "Website is required";
    }
    if (!contactForm.requirement.trim()) {
      newErrors.requirement = "Requirements are required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/enquiry/create", {
      // tokenId: token,
      name: contactForm.name,
      email: contactForm.email,
      website: contactForm.website,
      phone: contactForm.phone,
      requirement: contactForm.requirement,
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          showToast("Your Details are Submitted !", "success", "success");
          setContactForm({
            name: "",
            email: "",
            website: "",
            phone: "",
            requirement: "",
          });
        } else {
          showToast(response.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        console.error("Error in contact form", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <>
      <div className="contact_layout" style={{ position: "relative" }}>
        {loading && (
          <PremiumLoader fullPage={false} text="Loading Contact Page..." />
        )}
        <div className="contact_content">
          <div className="contact_text">
            <p className="contact_heading">
              Drop by anytime, we endeavor to answer all inquiries within 24
              hours on business days.
            </p>
            <p className="contact_heading_2">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Justo
              consectetur felis fermentum eget turpis quis.
            </p>
          </div>
          <div className="contact_card">
            <p className="card_text_1">Contact & Reach Us!</p>
            <p className="card_text_2">We are excited to work with you!</p>
            <form className="contact_form" onSubmit={handleSubmit}>
              <div className="contact_form_group">
                <input
                  type="text"
                  placeholder="Your Name"
                  name="name"
                  value={contactForm.name}
                  onChange={handleChange}
                  className={errors.name ? "input_error" : ""}
                />
                {errors.name && (
                  <span className="error_text">{errors.name}</span>
                )}
              </div>
              <div className="contact_form_group">
                <input
                  type="email"
                  placeholder="Your Email"
                  name="email"
                  value={contactForm.email}
                  onChange={handleChange}
                  className={errors.email ? "input_error" : ""}
                />
                {errors.email && (
                  <span className="error_text">{errors.email}</span>
                )}
              </div>
              <div className="contact_form_group">
                <input
                  type="number"
                  placeholder="Your Phone Number"
                  name="phone"
                  value={contactForm.phone}
                  onChange={handleChange}
                  className={errors.phone ? "input_error" : ""}
                />
                {errors.phone && (
                  <span className="error_text">{errors.phone}</span>
                )}
              </div>
              <div className="contact_form_group">
                <input
                  type="text"
                  placeholder="Website"
                  name="website"
                  value={contactForm.website}
                  onChange={handleChange}
                  className={errors.website ? "input_error" : ""}
                />
                {errors.website && (
                  <span className="error_text">{errors.website}</span>
                )}
              </div>
              <div className="contact_form_group">
                <input
                  type="text"
                  placeholder="Your Requirements"
                  name="requirement"
                  value={contactForm.requirement}
                  onChange={handleChange}
                  className={errors.requirement ? "input_error" : ""}
                />
                {errors.requirement && (
                  <span className="error_text">{errors.requirement}</span>
                )}
              </div>
              <button className="contact_form_btn" type="submit">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
